var map = {
	"./MDB Pro 4.4.3/js/modules (optional)/chart": 825
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/vendor ^\.\/MDB Pro .*\/js\/modules \(optional\)\/chart$
// module id = 824
// module chunks = 0